export enum JobStatusCode {
    Unknown = -1,
    Executing = 0,
    Completed = 1,
    Terminated = 2,
    Canceled = 3,
    CompletedWithErrors = 4,
    TimedOut = 5,
    Queued = 6,
    CompletedWithWarnings = 7,
}

export const GetJobStatusCodeValue = (value: number): string | undefined =>
    Object.keys(JobStatusCode).find((key) => JobStatusCode[key as keyof typeof JobStatusCode] === value) as
        | keyof typeof JobStatusCode
        | undefined;

export const GetJobStatusByKey = (value: string): JobStatusCode | undefined => JobStatusCode[value as keyof typeof JobStatusCode];
